import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="border-t border-[#E6E9F0] bg-white" data-testid="app-footer">
    <div className="mx-auto max-w-7xl px-6 py-6 text-sm text-[#4B647F]">
      <Link to="/om" className="text-[#103766] hover:underline" data-testid="footer-om-lenke">
        Om sida – kjelder og metode
      </Link>
      <span className="mx-2 text-[#C7D2DF]">·</span>
      Sida er laga av Per Arne Flatberg{" "}
      <a
        href="mailto:paffen@gmail.com"
        className="text-[#E52437] underline-offset-4 hover:underline"
        data-testid="footer-epost"
      >
        &lt;paffen@gmail.com&gt;
      </a>
      . Del gjerne
    </div>
  </footer>
);

export default Footer;
